import React, { isValidElement, cloneElement } from 'react'

const TextOrCustomElement = ({ value, textComponent: TextComponent, composeProps = (() => ({})), ...props }) => {
    if(!value) {
        return null
    }

    const isElement = isValidElement(value)
    if(!isElement && typeof value !== 'string') {
        return null
    }

    if(isElement) {
        return cloneElement(value, composeProps(value.props))
    }

    return (
        <TextComponent {...composeProps(props)}>
            {value}
        </TextComponent>
    )
}

export default TextOrCustomElement